import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Close = (props) => (
  <Icon viewBox="0 0 11 11" {...props}>
    <g>
      <path d="M6.613 5.492l4.27 4.27a.397.397 0 0 1 0 .56l-.56.56a.397.397 0 0 1-.56 0l-4.269-4.27-4.27 4.27a.397.397 0 0 1-.56 0l-.56-.56a.397.397 0 0 1 0-.56l4.27-4.27-4.27-4.269a.397.397 0 0 1 0-.56l.56-.56a.397.397 0 0 1 .56 0l4.27 4.27L9.763.103a.397.397 0 0 1 .56 0l.56.56a.397.397 0 0 1 0 .56l-4.27 4.269z"
        fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Close;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Close.js